import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type DynamicTranslationState = {
  requiredNamespaces: string[];
  language: string | undefined;
  loadedNamespaces: Record<string, string[]>;
};

const initialState: DynamicTranslationState = {
  requiredNamespaces: [],
  language: undefined,
  loadedNamespaces: {},
};

const dynamicTranslationSlice = createSlice({
  name: 'dynamicTranslation',
  initialState,
  reducers: {
    requireNamespaces: (state, action: PayloadAction<string[]>) => {
      state.requiredNamespaces = action.payload;
    },
    languageChanged: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    namespacesLoaded: (
      state,
      action: PayloadAction<Record<string, string[]>>
    ) => {
      state.loadedNamespaces = action.payload;
    },
  },
});

export const { requireNamespaces, languageChanged, namespacesLoaded } =
  dynamicTranslationSlice.actions;

export const dynamicTranslationReducer = dynamicTranslationSlice.reducer;
